import { useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Command } from '.';
import {
  ChangeImageForm,
  ChangeChannelForm,
  ChangeVolumeForm,
  ChangeNameRequestForm,
} from './commands';

export function CommandDialog({
  command,
  open,
  onChancel,
  onSubmit,
}: {
  command: Command;
  open: boolean;
  onChancel: () => void;
  onSubmit: (data: any) => void;
}) {
  const FormRequest = useMemo(() => {
    switch (command) {
      case Command.CHANGE_CHANNEL:
        return ChangeChannelForm;
      case Command.SET_NAME:
        return ChangeNameRequestForm;
      case Command.CHANGE_VOLUME:
        return ChangeVolumeForm;
      case Command.SET_IMAGE:
        return ChangeImageForm;
      default:
        return null;
    }
  }, [command]);

  if (!FormRequest) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onChancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Configuration change</DialogTitle>
          <DialogDescription>
            Configuration change will be applied to all the selected TVs.
          </DialogDescription>
        </DialogHeader>
        <FormRequest onSubmit={onSubmit} onChancel={onChancel} />
      </DialogContent>
    </Dialog>
  );
}
